import {
  RadioButtonChecked as RadioButtonCheckedIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
} from '@mui/icons-material';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Zoom,
} from '@mui/material';
import * as React from 'react';
import { Question } from '../../types/questionnaire.types';

interface MultipleChoiceQuestionProps {
  question: Question;
  response: string;
  onResponseChange: (questionId: string, value: string) => void;
}

export const MultipleChoiceQuestion: React.FC<MultipleChoiceQuestionProps> = ({
  question,
  response,
  onResponseChange,
}) => {
  if (!question.answers) return null;

  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <RadioGroup
        value={response || ''}
        onChange={(e) => onResponseChange(question.id, e.target.value)}
      >
        {question.answers.map((answer, idx) => (
          <Zoom
            in
            key={answer.id}
            timeout={400 + idx * 100}
            style={{ transitionDelay: `${idx * 50}ms` }}
          >
            <Box
              sx={{
                mb: 1.5,
                borderRadius: '12px',
                border: '1px solid',
                borderColor: response === answer.id ? '#667eea' : '#e5e7eb',
                background:
                  response === answer.id
                    ? 'linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%)'
                    : '#ffffff',
                '&:hover': {
                  background:
                    'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                  borderColor: '#667eea',
                },
              }}
            >
              <FormControlLabel
                value={answer.id}
                control={
                  <Radio
                    icon={
                      <RadioButtonUncheckedIcon
                        sx={{
                          color: '#d1d5db',
                          fontSize: '28px',
                          transition: 'all 0.2s ease',
                        }}
                      />
                    }
                    checkedIcon={
                      <RadioButtonCheckedIcon
                        sx={{
                          color: '#10b981',
                          fontSize: '28px',
                          filter:
                            'drop-shadow(0 2px 4px rgba(16, 185, 129, 0.3))',
                          transition: 'all 0.2s ease',
                        }}
                      />
                    }
                    sx={{
                      padding: '8px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(16, 185, 129, 0.08)',
                        transform: 'scale(1.1)',
                      },
                      '&:hover .MuiSvgIcon-root': {
                        color: '#10b981',
                      },
                      '&.Mui-checked': {
                        animation: 'pulse 0.3s ease-in-out',
                      },
                    }}
                  />
                }
                label={
                  <span dangerouslySetInnerHTML={{ __html: answer.text }} />
                }
                sx={{
                  width: '100%',
                  pl: 2,
                  pr: 2,
                  pt: 1.5,
                  pb: 1.5,
                  '& .MuiFormControlLabel-label': {
                    fontFamily: 'Roboto-Regular !important',
                    fontSize: '11pt !important',
                    color: '#374151 !important',
                    lineHeight: 1.5,
                  },
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    borderColor: '#667eea',
                    background: 'rgba(102, 126, 234, 0.03)',
                    transform: 'translateX(4px)',
                  },
                }}
              />
            </Box>
          </Zoom>
        ))}
      </RadioGroup>
    </FormControl>
  );
};
